import { toast } from "react-toastify";
import URLS from "../services/URLS";
import {
  EXPORT_BOOKING_CANCELLATION_CSV_API,
  EXPORT_BOOKING_HISTORY_CSV_API,
  EXPORT_FINANCE_CSV_API,
  EXPORT_SERVICE_PROVIDER_CSV,
  EXPORT_USER_CSV,
  EXPORTBOOKING,
  EXPORTHOTEL,
} from "../services/ApiCalls";
import { accountType, statusEnum } from "./const";

export const changePageToOne = (body, setBody) => {
  const newBody = { ...body, page: 1 };
  setBody((p) => newBody);
  return newBody;
};

export const changeBody = (body, setBody, key, value) => {
  const newBody = {
    ...body,
    [key]: value,
  };
  setBody((p) => newBody);
  return newBody;
};

export const capitalizedFirstAlphaBet = (value) => {
  if (!value || typeof value !== "string") return;
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export const removeUnderScoreAndCapitalizeFirstLetter = (value) => {
  if (!value || typeof value !== "string") return;
  const formattedString = value.replace(/_/g, " ").toLowerCase();

  return capitalizedFirstAlphaBet(formattedString);
};

export const makingOptionsFromArr = (arr) => {
  return arr.map((type) => ({
    label: removeUnderScoreAndCapitalizeFirstLetter(type),
    value: type,
  }));
};

export const makingOptionsFromData = (arr, labelKey, valueKey) => {
  return arr.map((item) => ({
    label: removeUnderScoreAndCapitalizeFirstLetter(item[labelKey]),
    value: item[valueKey],
  }));
};

export const removeUnderScore = (message) => {
  if (!message || typeof message !== "string") {
    toast.dismiss();

    return toast.warning("something went wrong");
  }

  return message.split("_").join(" ");
};

export function createObjectURL(object) {
  return window.URL
    ? window.URL.createObjectURL(object)
    : window.webkitURL.createObjectURL(object);
}

export const exportCsvHandler = async (type, setLoader, bodyObj = {}) => {
  try {
    setLoader && setLoader(true);

    let res;
    if (type === "users") {
      res = await EXPORT_USER_CSV("USER");
    } else if (type === "bookingcsv") {
      res = await EXPORTBOOKING("BOOKING");
    } else if (type === "accounting") {
      res = await EXPORTACCOUNTING("ACCOUNTING");
    } else if (type === "hotel") {
      res = await EXPORTHOTEL({ ...bodyObj });
    } else if (type === "hoteladmin") {
      res = await EXPORT_SERVICE_PROVIDER_CSV("HOTELADMIN");
    } else if (type === "bookinghistorycsv") {
      res = await EXPORT_BOOKING_HISTORY_CSV_API({ ...bodyObj });
    } else if (type === "bookingCancellationCsv") {
      res = await EXPORT_BOOKING_CANCELLATION_CSV_API({
        "type": "cancellation"
      });
    } else if (type === "financeCsv") {
      res = await EXPORT_FINANCE_CSV_API({
        ...bodyObj
      });
    } else {
      throw new Error("Invalid CSV type");
    }

    console.log(res, "res======<>csv====");

    // Correct check for HTTP 200
    if (res.status === 200 && res.data) {
      const blob = new Blob([res.data], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${type} Report.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);

      setLoader && setLoader(false);
      toast.success("CSV downloaded successfully!");
    } else {
      setLoader && setLoader(false);
      toast.error("Something went wrong while exporting CSV.");
    }
  } catch (error) {
    console.error("CSV export error:", error);
    setLoader && setLoader(false);
    toast.error("Something went wrong while exporting CSV.");
  }
};

export const catchAsync = (fn, setLoader, callBack) => {
  return (...arg) =>
    fn(...arg).catch((error) => {
      toast.dismiss();
      toast.error("something went wrong");
      setLoader && setLoader(false);
      callBack && callBack();
      console.log(error, "error");
    });
};

export const checkResponse = ({
  res,
  setData,
  setTotal,
  showSuccess,
  dataToSet,
  setLoader,
  totalCount,
}) => {
  if (res?.data?.status === "success") {
    console.log(res, "res== data handler");
    setData && setData(dataToSet ? dataToSet(res?.data) : res?.data?.data);
    setTotal &&
      setTotal(totalCount || res?.data?.totalcount || res?.data?.total);
    showSuccess && (toast.dismiss(), toast.success(res?.data?.message));
    setLoader && setLoader(false);
    return true;
  } else {
    console.log(res, "res error")
    toast.dismiss();
    toast.error(res?.data?.message || res?.message);
    setLoader && setLoader(false);
    return false;
  }
};

export function getLast7Days() {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const dates = [];
  for (let i = 1; i <= 7; i++) {
    const date = new Date();
    date.setDate(date.getDate() - i);
    const day = date.getDate();
    const month = months[date.getMonth()];
    dates.push(`${day} ${month}`);
  }

  return dates.reverse();
}

export const findLabelOfStatus = (val) => {
  if (!val) return val;
  if (typeof val === "object") return "";
  const statusObject = Object.values(statusEnum).find(
    (status) => status.value === val
  );
  return statusObject ? statusObject?.label : val;
};

export const findLabelOfAccountType = (val) => {
  if (!val) return val;
  if (typeof val === "object") return "";
  const accountTypeEnum = Object.values(accountType).find(
    (status) => status.value === val
  );
  return accountTypeEnum ? accountTypeEnum?.label : val;
};
export const makeParams = (data) => {
  if (!data && typeof data !== "object") return;

  let paramString = "?";

  Object.keys(data).forEach(
    (item) => (paramString += `${item}=${data[item]}&`)
  );

  return paramString;
};
